const _listeners = new Map();

export function on(event, fn) {
    if (!_listeners.has(event)) _listeners.set(event, []);
    _listeners.get(event).push(fn);
}

export function off(event, fn) {
    if (!_listeners.has(event)) return;
    _listeners.set(event, _listeners.get(event).filter(f => f !== fn));
}

export function emit(event, data) {
    _listeners.get(event)?.forEach(fn => fn(data));
}
